module.exports = __webpack_public_path__ + "img/business_license_template.42b382f2.png";